"use strict";
async function sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "sleep", {
    enumerable: !0,
    get: function() {
        return sleep;
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL1NsZWVwLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBhc3luYyBmdW5jdGlvbiBzbGVlcChtczogbnVtYmVyKTogUHJvbWlzZTx2b2lkPiB7XG4gICAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlKSA9PiBzZXRUaW1lb3V0KHJlc29sdmUsIG1zKSlcbn1cbiJdLCJuYW1lcyI6WyJzbGVlcCIsIm1zIiwiUHJvbWlzZSIsInJlc29sdmUiLCJzZXRUaW1lb3V0Il0sIm1hcHBpbmdzIjoiO0FBQU8sZUFBZUEsTUFBTUMsRUFBVTtJQUNsQyxPQUFPLElBQUlDLFFBQVEsQ0FBQ0MsVUFBWUMsV0FBV0QsU0FBU0Y7QUFDeEQ7OzttQ0FGc0JEOzs7ZUFBQUEifQ==